<template>
    <div class="mobile-nav-list">
        <!-- <pre v-text="menu"></pre> -->

        <div class="mobile-nav-list--main-menu">
            <div class="grid--container grid--container__no-edge">
                <ul class="u-reset mobile-nav-list--items">
                    <li v-for="(navItem, navItemIdx) in menu" class="mobile-nav-list--item">
                        <div class="mobile-nav-list--item-root">
                            <router-link :to="navItem.path" class="u-reset mobile-nav-list--link">
                                <span class="mobile-nav-list--title" v-text="navItem.label"></span>
                            </router-link>
                            <button class="mobile-nav-list--dropdown-btn" :class="dropdownBtnClasses(navItemIdx)"
                                @click="updateState(navItemIdx)">
                                <cmp-icon class="mobile-nav-list--dropdown-icon"
                                        symbol="navigation_mobile_down"
                                        size="x-small">
                                </cmp-icon>
                            </button>
                        </div>

                        <cmp-accordion :is-active="accordionStates[navItemIdx]" :passive-mode="true">
                            <!-- body -->
                            <template slot="body" slot-scope="props">
                                <div class="mobile-nav-list--accordion-body">
                                    <ul class="u-reset mobile-nav-list--sub-items">
                                        <li v-for="(subNavItem, subNavItemIdx) in navItem.children"
                                                class="mobile-nav-list--sub-item">
                                            <router-link :to="subNavItem.path"
                                                    class="u-reset mobile-nav-list--sub-link"
                                                    v-html="subNavItem.label">
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </cmp-accordion>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mobile-nav-list--meta-menu">
            <!-- <pre v-text="meta"></pre> -->
            <cmp-meta-nav facet="mobile" :container="meta"></cmp-meta-nav>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';


    export default {
        mixins: [
            bemMixin('mobile-nav-list'),
        ],
        props: {
            menu: Array,
            meta: Object,
        },
        data() {
            return {
                accordionStates: [],
            };
        },
        methods: {
            updateState(updateIdx, updateVal) {
                if (updateVal == null) {
                    updateVal = !this.accordionStates[updateIdx];
                }

                if (updateVal) {
                    this.accordionStates.forEach((item, idx) => {
                        if (updateIdx === idx) {
                            return;
                        }

                        this.accordionStates.splice(idx, 1, false);
                    });
                }

                this.accordionStates.splice(updateIdx, 1, updateVal);
            },
            dropdownBtnClasses(idx) {
                return [
                    this.bemAdd(this.accordionStates[idx] ? 'is-active' : '', 'dropdown-btn'),
                ];
            },
        },
        watch: {
            menu: {
                handler(children) {
                    if (children.length <= this.accordionStates.length) {
                        return;
                    }

                    children.forEach((plugin, idx) => {
                        this.accordionStates[idx] = this.accordionStates[idx] || false;
                    });
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?a22d7220